const isMobile = () => {
  const isOrientation = window.orientation? true : false;
  const screenSize = window.screen.width? window.screen.width : 0;
  return isOrientation || (screenSize <= 600 );
}


const triggerPointCalculator = (initialPoint, number, ratio) => (initialPoint + (number * ratio))

export {
  isMobile,
  triggerPointCalculator
}